// Romanian translations for system statuses
export const ORDER_STATUS_RO = {
    pending: "În așteptare",
    confirmed: "Confirmată",
    paid: "Plătită",
    processing: "În procesare",
    shipped: "Expediată",
    delivered: "Livrată",
    canceled: "Anulată",
    refunded: "Rambursată",
};

export const PAYMENT_STATUS_RO = {
    pending: "În așteptare",
    paid: "Plătită",
    cod_pending: "Ramburs la livrare",
    failed: "Eșuată",
    refunded: "Rambursată",
};

export const TICKET_STATUS_RO = {
    open: "Deschis",
    in_progress: "În lucru",
    waiting_client: "Așteptăm clientul",
    resolved: "Rezolvat",
    closed: "Închis",
};

export const TICKET_PRIORITY_RO = {
    low: "Scăzută",
    normal: "Normală",
    high: "Ridicată",
    urgent: "Urgentă",
};

export const TICKET_CATEGORY_RO = {
    general: "Generală",
    warranty: "Garanție",
    installation: "Instalare",
    malfunction: "Defecțiune",
    return: "Retur",
    other: "Altă problemă",
};

export const APPOINTMENT_STATUS_RO = {
    pending: "În așteptare",
    pending_schedule: "Așteaptă programare",
    confirmed: "Confirmată",
    in_progress: "În desfășurare",
    done: "Finalizată",
    canceled: "Anulată",
};

export const statusRO = (key, dict = ORDER_STATUS_RO) => dict[key] || key;
